'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _envType = require('./envType');

var _envType2 = _interopRequireDefault(_envType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// will be replaced by google tag manager container ids
var GA_TRACKING_ID_TEST = 'UA-55332635-8';
var GA_TRACKING_ID_PROD = 'UA-21174015-74';

var Analytics = function () {
    function Analytics() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Analytics);

        var az = config.az,
            env = config.env,
            feLogUrl = config.feLogUrl;

        this.az = az;
        this.env = env;
        this.feLogUrl = feLogUrl;
    }

    _createClass(Analytics, [{
        key: 'initialize',
        value: function initialize() {
            this.initializeGoogleTagManager();
        }

        /**
         * Initialize google tag manager for tracking google analytics by appending init scripts to <head>
         */

    }, {
        key: 'initializeGoogleTagManager',
        value: function initializeGoogleTagManager() {
            this.GA_TRACKING_ID = this.env === _envType2.default.PROD ? GA_TRACKING_ID_PROD : GA_TRACKING_ID_TEST;

            if ((typeof document === 'undefined' ? 'undefined' : _typeof(document)) !== undefined) {
                var initGaConfig = {
                    type: 'text/javascript',
                    src: 'https://www.googletagmanager.com/gtag/js?id=' + this.GA_TRACKING_ID,
                    async: true
                };

                var configureGaConfig = {
                    type: 'text/javascript',
                    text: 'window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments)}; gtag("js", new Date()); gtag("config", \'' + this.GA_TRACKING_ID + '\');'
                };

                var initGaScript = this.generateScriptTag(initGaConfig);
                var configureGaScript = this.generateScriptTag(configureGaConfig);

                document.head.appendChild(initGaScript);
                document.head.appendChild(configureGaScript);
            }
        }
    }, {
        key: 'generateScriptTag',
        value: function generateScriptTag(props) {
            var script = document.createElement('script');
            Object.keys(props).forEach(function (propKey) {
                script[propKey] = props[propKey];
            });
            return script;
        }
    }, {
        key: 'pushGoogleTagEvent',
        value: function pushGoogleTagEvent(data) {
            var event = data.event,
                category = data.category,
                action = data.action,
                label = data.label,
                value = data.value,
                customParams = _objectWithoutProperties(data, ['event', 'category', 'action', 'label', 'value']);

            if (!event) {
                console.log('error: must specify event in GA data: ', data);
                return;
            }

            gtag('event', event, _extends({
                event_category: category,
                event_action: action,
                event_label: label,
                value: value
            }, customParams));
        }

        /**
         * Track page view
         * @param {object} data - page view event data in the format: { action, label, value } where all fields are optional
         */

    }, {
        key: 'trackPageview',
        value: function trackPageview(data) {
            data.event = 'page_view';
            this.pushGoogleTagEvent(data);
        }

        /**
         * Track event
         * @param {object} data - event data in the format: { event, category, action, label, value }
         * where 'event' is required and other fields are optional.
         */

    }, {
        key: 'trackEvent',
        value: function trackEvent() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.pushGoogleTagEvent(data);
        }

        /**
         * Set custom dimension
         * @param {object} data - cusotm dimension data in the format: { dimension<Index>: dimension_name }
         * where <Index> is a number representing the index of the custom metric.
         */

    }, {
        key: 'setCustomDimensions',
        value: function setCustomDimensions(data) {
            if (this.GA_TRACKING_ID) {
                console.log('setting custom dimensions with data: ', data);
                gtag('config', this.GA_TRACKING_ID, { custom_map: data });
            } else {
                console.log('GA_TRACKING_ID not set. Must initialize GA before setting custom dimensions.');
            }
        }

        /**
         * Log error string to splunk
         */

    }, {
        key: 'logFeInfo',
        value: function logFeInfo(infoObj) {
            _axios2.default.post(this.feLogUrl, infoObj, {
                headers: { 'Content-Type': 'application/json' }
            });
        }
    }]);

    return Analytics;
}();

;

exports.default = Analytics;
//# sourceMappingURL=Analytics.js.map